import { FieldBase } from './field-base';

export class CheckboxQuestion extends FieldBase<string> {
    label: string;

    constructor(options: {} = {}) {
        super(options);
        this.label = options['label'] || '';
    }
}